// import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DrNishaKapoorContent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "32px",
            textAlign: "left",
          }}
        >
          <img
            src="/Doctorprofile.png"
            alt="Dr. Nisha Kapoor"
            style={{
              width: "220px",
              height: "220px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #ddd",
              flexShrink: 0,
            }}
          />

          <div
            className="vertical-divider"
            style={{
              width: "2px",
              backgroundColor: "#ccc",
              height: "100%",
              minHeight: "160px",
              display: "none",
            }}
          ></div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              flex: 1,
              minWidth: "260px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
              className="content-container"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
                className="inner-content"
              >
                <div style={{ flex: 1 }}>
                  <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Dr. Nisha Kapoor
                  </h2>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Specialization:</strong> Senior Medical Advisor & Mentor
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Experience:</strong> 30+ Years
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Degrees:</strong> MBBS, MD, FRCOG (London) from Premier Institutions
                  </p>
                </div>

                <div
                  className="vertical-divider"
                  style={{
                    width: "2px",
                    backgroundColor: "#ccc",
                    height: "100%",
                    minHeight: "160px",
                    display: "none",
                  }}
                ></div>

                <div style={{ flex: 1 }}>
                  <p
                    style={{
                      fontStyle: "italic",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      color: "#444",
                      marginTop: "4px",
                    }}
                  >
                    "For too long, maternal care has been a clinical transaction. We are here to
                    transform it into a supportive, human relationship. I am at Myprega to help build
                    that future."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     <style>
        {`
          @media (min-width: 768px) {
            .vertical-divider {
              display: block !important;
            }
      
            .inner-content {
              flex-direction: row !important;
            }
          }
      
          @media (max-width: 767px) {
            .doctor-intro-container {
              flex-direction: column;
              align-items: center !important;
              text-align: center !important;
            }
      
            .inner-content {
              flex-direction: column !important;
              align-items: center !important;
              text-align: center !important;
            }
      
            .content-container {
              align-items: center !important;
              text-align: center !important;
            }
          }
        `}
      </style>


      <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
        <h3>My Philosophy on Pregnancy Care:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          With over three decades of practice, my focus has shifted from treating individual patients to fixing a broken system. My philosophy is that care must be holistic, continuous, and deeply human. A mother’s mental and emotional state is as critical as her physical parameters. We must use technology not to create distance, but to enable deeper, more consistent human connection.
        </p>

        <h3 style={{ marginTop: "32px" }}>Why I Chose Myprega:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          I didn't just choose Myprega; I chose to help build it. This is the manifestation of everything I believe is missing in traditional healthcare. It’s a system designed from the ground up for the mother's peace of mind. By mentoring our doctors in the Myprega way, I am helping to create a new generation of medical experts who are not just clinicians, but true partners in care.
        </p>

        <h3 style={{ marginTop: "32px" }}>Beyond the Clinic:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          I am passionate about mentoring young doctors and often give guest lectures at medical colleges. I unwind by playing the sitar, which I've been learning for the last five years—it's a humbling lesson in discipline and beauty. My library is filled with books on leadership and systems thinking.
        </p>
      </div>

      <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "24px",
            paddingTop: "32px",
          }}
        >
          {/* Favourite Book */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              📖 Favourite Book
            </p>
            <p style={{ color: "#333" }}>The Fifth Discipline by Peter Senge</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Singer */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🎵 Favourite Musician
            </p>
            <p style={{ color: "#333" }}>Ravi Shankar</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Pastime */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🎼 Favourite Pastime
            </p>
            <p style={{ color: "#333" }}>
              Playing the sitar <br />
              Mentoring and guest lecturing
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DrNishaKapoorContent;
